import { useMutation } from '@apollo/client'
import { CLOSE_EVENT } from './operations'

interface Props {
  onCompleted?: () => void
}

interface CloseEventVariables {
  id: string
}

interface CloseEvent {
  closeEvent: boolean
}

export const useCloseEvent = ({ onCompleted }: Props) =>
  useMutation<CloseEvent, CloseEventVariables>(CLOSE_EVENT, { onCompleted })
